import { Component } from '@angular/core';
importProvidersFrom
import { Router } from '@angular/router';
import { GeneralService } from '../../services/general.service';
import { DriverService } from '../../services/driver.service';
import { environment } from '../../../environments/environment';
import { importProvidersFrom } from '@angular/core';

@Component({
    selector: 'app-driver',
    templateUrl: './driver.component.html',
    styleUrls: ['./driver.component.scss'],
    standalone: false
})
export class DriverComponent {

    constructor(
        public generalService: GeneralService,
        private _router: Router,
        private driverService: DriverService
    ) {

    }

    ngOnInit(): void {

    }
}
